import script from "./TestimonialSection.vue?vue&type=script&setup=true&lang=js"
export * from "./TestimonialSection.vue?vue&type=script&setup=true&lang=js"

import "./TestimonialSection.vue?vue&type=style&index=0&id=35f2849e&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-35f2849e"]])

export default __exports__